<div class="avatar" [matMenuTriggerFor]="menu" [class.disabled]="!showMenu">
  @if (!userCard.profilePictureUrl) {
    <mat-icon>account_circle</mat-icon>
  }
  @if (userCard.profilePictureUrl) {
    <img
      class="user-icon"
      [src]="userCard.profilePictureUrl | appendDomain"
      alt="{{ userCard.name }}"
    />
  }
</div>
<div class="info" [matMenuTriggerFor]="menu" [class.disabled]="!showMenu">
  <div class="name" [attr.tile]="userCard.name" [class.wrap]="wrap">
    {{ userCard.name }}
  </div>
  <div class="position" [attr.title]="userCard.position" [class.wrap]="wrap">
    {{ userCard.position }}
  </div>
  <div class="roles" [class.wrap]="wrap">{{ userCard.roles }}</div>
</div>
<mat-menu #menu="matMenu">
  <ng-content></ng-content>
</mat-menu>
